export const ALLOTMENT_STATUS = {
  ALLOCABLE: 'allocable',
  LIMITED: 'limited',
  SOLD_OUT: 'soldOut'
} as const;

export type AllotmentStatusType =
  (typeof ALLOTMENT_STATUS)[keyof typeof ALLOTMENT_STATUS];

export const ALLOTMENT_THRESHOLD = 30;
